import { adminBaseQueryWrapper } from "@/utils/rtkHelper";
import { createApi } from "@reduxjs/toolkit/query/react";
import { StockReport, StockReportResult } from "@/types/OrderItem";

export interface ItemSearch {
  startAt: number;
  pageSize: number;
  sortDesc: boolean;
}

export interface ItemSearchResult {
  items: Item[];
  pageSize: number;
  startAt: number;
  sortDesc: boolean;
  total: number;
}

interface Item {
  id: number;
  item_detail: string;
  account: string;
  rate: string;
  discount: string;
  taxable: string;
  amount: string;
}

export const itemsApi = createApi({
  reducerPath: "itemsApi",
  baseQuery: adminBaseQueryWrapper,
  tagTypes: ["items"],
  keepUnusedDataFor: 0,
  endpoints: (builder) => ({
    getItemById: builder.query<any, number>({
      query: (id) => `/items/${id}`,
      providesTags: ["items"],
    }),

    searchItems: builder.query<ItemSearchResult, ItemSearch>({
      query: (input) => ({
        url: `/items/search`,
        method: "POST",
        body: input,
      }),
      providesTags: ["items"],
    }),

    createItem: builder.mutation<void, any>({
      query: (input) => ({
        url: `/items`,
        method: "POST",
        body: input,
      }),
      invalidatesTags: ["items"],
    }),

    updateItem: builder.mutation<void, { id: number; data: any }>({
      query: ({ id, data }) => ({
        url: `/items/${id}`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: ["items"],
    }),

    deleteItem: builder.mutation<void, number>({
      query: (id) => ({
        url: `/items/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["items"],
    }),
    
    getStockReport: builder.query<StockReportResult, StockReport>({
      query: (input) => ({
        url: `/flipkart-order/stock/stock_report`,
        method: "POST",
        body: input,
      }),
    }),
  }),
});

export const {
  useGetItemByIdQuery,
  useSearchItemsQuery,
  useCreateItemMutation,
  useUpdateItemMutation,
  useDeleteItemMutation,
  useGetStockReportQuery,
} = itemsApi;
